module.exports = __webpack_public_path__ + "img/google08.5fa957ae.jpg";